import { render, staticRenderFns } from "./TotalPrice.vue?vue&type=template&id=3cbf7440&scoped=true&"
import script from "./TotalPrice.vue?vue&type=script&lang=js&"
export * from "./TotalPrice.vue?vue&type=script&lang=js&"
import style0 from "./TotalPrice.vue?vue&type=style&index=0&id=3cbf7440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf7440",
  null
  
)

export default component.exports